const axios = require("axios");

var postThiSinh = (payload) => {
	let formFiles = new FormData();
	let data = {
		thiSinh: payload.thiSinh,
		nguyenVongs: payload.nguyenVongs,
		dotDangKyThiSinh: payload.dotDangKyThiSinh,
		diems: payload.diems
	};
	data.nguyenVongs.forEach((i) => {
		if (!i.toHopId) {
			i.toHopId = 0;
		}
	});
	for (let i = 0; i < payload.file.length; i++) {
		formFiles.append("fileHocBa", payload.file[i]);
	}
	formFiles.append("jsonData", JSON.stringify(data));
	return axios
		.post(`${process.env.VUE_APP_API}${process.env.VUE_APP_THISINH}`, formFiles)
		.then((response) => response)
		.catch((error) => error.response);
};

const postThiSinhCaoHoc = (payload) => {
	let formFiles = new FormData();
	let data = {
		thiSinh: payload.thiSinh,
		nguyenVongs: payload.nguyenVongs,
		dotDangKyThiSinh: payload.dotDangKyThiSinh,
	};
	if (payload.fileCmnd)
    for (let i = 0; i < payload.fileCmnd.length; i++) {
      let file = payload.fileCmnd[i];
      formFiles.append("fileCmnd", file);
    } else {
		formFiles.append("fileCmnd", []);
	}
	if (payload.fileBaiBao.length > 0) {
		for (let i = 0; i < payload.fileBaiBao.length; i++) {
			formFiles.append("fileBaiBao", payload.fileBaiBao[i]);
		}
	} else {
		formFiles.append("fileBaiBao", []);
	}
	if (payload.fileDeTai.length > 0) {
		for (let i = 0; i < payload.fileDeTai.length; i++) {
			formFiles.append("fileDeTai", payload.fileDeTai[i]);
		}
	} else {
		formFiles.append("fileDeTai", []);
	}
	if (payload.chungChiNgoaiNgu.length > 0) {
		for (let i = 0; i < payload.chungChiNgoaiNgu.length; i++) {
			formFiles.append("chungChiNgoaiNgu", payload.chungChiNgoaiNgu[i]);
		}
	} else {
		formFiles.append("chungChiNgoaiNgu", []);
	}
	if (payload.fileMinhChung.length > 0) {
		for (let i = 0; i < payload.fileMinhChung.length; i++) {
			formFiles.append("fileMinhChung", payload.fileMinhChung[i]);
		}
	} else {
		formFiles.append("fileMinhChung", []);
	}
	formFiles.append("jsonData", JSON.stringify(data));
	return axios
		.post(`${process.env.VUE_APP_API}${process.env.VUE_APP_THISINH}/caohoc`, formFiles)
		.then((response) => response)
		.catch((error) => error.response);
};

var findThiSinhDKHocBa = async (payload) => {
	return await axios
		.get(
			`${process.env.VUE_APP_API}${process.env.VUE_APP_THISINH}${process.env.VUE_APP_TIMTHISINHDKHB}`,
			{
				params: {
					soCmnd: payload.soCmnd,
					regCode: payload.regCode,
				},
			},
		)
		.then((response) => response)
		.catch((error) => error.response);
};
var findThongTinChinhSua = async (payload) => {
	return await axios
		.get(
			`${process.env.VUE_APP_API}${process.env.VUE_APP_THISINH}${process.env.VUE_APP_THONGTINCHINHSUA}`,
			{
				params: {
					soCmnd: payload.soCmnd,
					regCode: payload.regCode,
				},
			},
		)
		.then((response) => response)
		.catch((error) => error.response);
};

var findThiSinhDKTHPT = async (payload) => {
	return await axios
		.get(
			`${process.env.VUE_APP_API}${process.env.VUE_APP_THISINH}${process.env.VUE_APP_TIMTHISINHDKTHPT}`,
			{
				params: {
					soCmnd: payload.soCmnd,
					dotDangKyId: payload.dotDangKyId,
				},
			},
		)
		.then((response) => response)
		.catch((error) => error.response);
};

var findThiSinhByCMND = async (soCmnd) => {
	return await axios
		.get(
			`${process.env.VUE_APP_API}${process.env.VUE_APP_THISINH}${process.env.VUE_APP_CMND}`,
			{
				params: {
					soCmnd: soCmnd,
				},
			},
		)
		.then((response) => response)
		.catch((error) => error.response);
};

var updateThiSinh = (payload) => {
	let formFiles = new FormData();
	let data = {
		thiSinh: payload.thiSinh,
		nguyenVongs: payload.nguyenVongs,
		ksNguyenVongs: payload.ksNguyenVongs,
		diems: payload.diems
	};
	if (payload.file)
		for (let i = 0; i < payload.file.length; i++) {
			formFiles.append("fileHocBa", payload.file[i]);
		}
	// formFiles.append("fileHocBa", payload.file);
	formFiles.append("jsonData", JSON.stringify(data));
	formFiles.append("dotDangKyId", JSON.stringify(payload.dotDangKyId));
	return axios
		.put(
			`${process.env.VUE_APP_API}${process.env.VUE_APP_THISINH}/${payload.thiSinh.thiSinhId}`,
			formFiles
		)
		.then((response) => response)
		.catch((error) => error.response);
};

var checkExistCmnd = (soCmnd) => {
	return axios
		.get(
			`${process.env.VUE_APP_API}${process.env.VUE_APP_THISINH}/${process.env.VUE_APP_CHECKCMND}`,
			{
				params: { soCmnd: soCmnd },
			},
		)
		.then((response) => response)
		.catch((error) => error.response);
};

var checkExistSbd = (sbd) => {
	return axios
		.get(
			`${process.env.VUE_APP_API}${process.env.VUE_APP_THISINH}/${process.env.VUE_APP_CHECKSBD}`,
			{
				params: { sbd: sbd },
			},
		)
		.then((response) => response)
		.catch((error) => error.response);
};
var downloadFileDangKy = (regCode) => {
	return axios.get(`${process.env.VUE_APP_API}${process.env.VUE_APP_DOWNLOAD}/dangky/${regCode}`, {
		reportProgress: true,
		responseType: 'blob',
	}).then((response) => {
		if (response.status == 200) {
			const url = URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }))
			const link = document.createElement('a')
			link.href = url
			link.setAttribute(
				'download', `${regCode}_dang_ky.pdf`
			)
			document.body.appendChild(link)
			link.click();
		}
		return response;

	})
		.catch((error) => error.response);
}

var downloadFileHoSo = (thiSinhId) => {
	return axios.get(`${process.env.VUE_APP_API}${process.env.VUE_APP_DOWNLOAD}/hocba/${thiSinhId}`, {
		reportProgress: true,
		responseType: 'blob',
	}).then((response) => {
		if (response.status == 200) {
			const url = URL.createObjectURL(new Blob([response.data]))
			const link = document.createElement('a')
			link.href = url
			link.setAttribute(
				'download', `${thiSinhId}_ho_so.zip`
			)
			document.body.appendChild(link)
			link.click();
		}
		return response;

	})
		.catch((error) => error.response);
}

const updateThiSinhCaoHoc = (payload) => {
	let formFiles = new FormData();
	let data = {
		thiSinh: payload.thiSinh,
		nguyenVongs: payload.nguyenVongs,
		dotDangKyThiSinh: payload.dotDangKyThiSinh,
	};
	if (payload.fileCmnd)
    for (let i = 0; i < payload.fileCmnd.length; i++) {
      let file = payload.fileCmnd[i];
      formFiles.append("fileCmnd", file);
    } else {
		formFiles.append("fileCmnd", []);
	}
	if (payload.fileBaiBao.length > 0) {
		for (let i = 0; i < payload.fileBaiBao.length; i++) {
			formFiles.append("fileBaiBao", payload.fileBaiBao[i]);
		}
	} else {
		formFiles.append("fileBaiBao", []);
	}
	if (payload.fileDeTai.length > 0) {
		for (let i = 0; i < payload.fileDeTai.length; i++) {
			formFiles.append("fileDeTai", payload.fileDeTai[i]);
		}
	} else {
		formFiles.append("fileDeTai", []);
	}
	if (payload.chungChiNgoaiNgu.length > 0) {
		for (let i = 0; i < payload.chungChiNgoaiNgu.length; i++) {
			formFiles.append("chungChiNgoaiNgu", payload.chungChiNgoaiNgu[i]);
		}
	} else {
		formFiles.append("chungChiNgoaiNgu", []);
	}
	if (payload.fileMinhChung.length > 0) {
		for (let i = 0; i < payload.fileMinhChung.length; i++) {
			formFiles.append("fileMinhChung", payload.fileMinhChung[i]);
		}
	} else {
		formFiles.append("fileMinhChung", []);
	}
	formFiles.append("jsonData", JSON.stringify(data));
  formFiles.append("dotDangKyId", JSON.stringify(payload.dotDangKyId));
	return axios
		.put(`${process.env.VUE_APP_API}${process.env.VUE_APP_THISINH}/${payload.thiSinh.thiSinhId}/caohoc`, formFiles)
		.then((response) => response)
		.catch((error) => error.response);
};

export const ThiSinhService = {
	postThiSinh,
	findThiSinhDKHocBa,
	updateThiSinh,
	findThiSinhByCMND,
	checkExistCmnd,
	findThiSinhDKTHPT,
	findThongTinChinhSua,
	downloadFileDangKy,
	downloadFileHoSo,
	checkExistSbd,
	postThiSinhCaoHoc,
  updateThiSinhCaoHoc,
};
